import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IBlogTable } from 'app/shared/model/blog-table.model';
import { getEntity, updateEntity, createEntity, reset } from './blog-table.reducer';

export const BlogTableUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const blogTableEntity = useAppSelector(state => state.blogTable.entity);
  const loading = useAppSelector(state => state.blogTable.loading);
  const updating = useAppSelector(state => state.blogTable.updating);
  const updateSuccess = useAppSelector(state => state.blogTable.updateSuccess);

  const handleClose = () => {
    navigate('/blog-table');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.createdAt = convertDateTimeToServer(values.createdAt);
    values.modifiedAt = convertDateTimeToServer(values.modifiedAt);

    const entity = {
      ...blogTableEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          createdAt: displayDefaultDateTime(),
          modifiedAt: displayDefaultDateTime(),
        }
      : {
          ...blogTableEntity,
          createdAt: convertDateTimeFromServer(blogTableEntity.createdAt),
          modifiedAt: convertDateTimeFromServer(blogTableEntity.modifiedAt),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="reachamyApp.blogTable.home.createOrEditLabel" data-cy="BlogTableCreateUpdateHeading">
            <Translate contentKey="reachamyApp.blogTable.home.createOrEditLabel">Create or edit a BlogTable</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="blog-table-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('reachamyApp.blogTable.title')}
                id="blog-table-title"
                name="title"
                data-cy="title"
                type="text"
              />
              <ValidatedField
                label={translate('reachamyApp.blogTable.blogContent')}
                id="blog-table-blogContent"
                name="blogContent"
                data-cy="blogContent"
                type="text"
              />
              <ValidatedField
                label={translate('reachamyApp.blogTable.categoryId')}
                id="blog-table-categoryId"
                name="categoryId"
                data-cy="categoryId"
                type="text"
              />
              <ValidatedField
                label={translate('reachamyApp.blogTable.imageId')}
                id="blog-table-imageId"
                name="imageId"
                data-cy="imageId"
                type="text"
              />
              <ValidatedField
                label={translate('reachamyApp.blogTable.postAsNgo')}
                id="blog-table-postAsNgo"
                name="postAsNgo"
                data-cy="postAsNgo"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('reachamyApp.blogTable.ngoUserId')}
                id="blog-table-ngoUserId"
                name="ngoUserId"
                data-cy="ngoUserId"
                type="text"
              />
              <ValidatedField
                label={translate('reachamyApp.blogTable.createdBy')}
                id="blog-table-createdBy"
                name="createdBy"
                data-cy="createdBy"
                type="text"
              />
              <ValidatedField
                label={translate('reachamyApp.blogTable.createdAt')}
                id="blog-table-createdAt"
                name="createdAt"
                data-cy="createdAt"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('reachamyApp.blogTable.modifiedBy')}
                id="blog-table-modifiedBy"
                name="modifiedBy"
                data-cy="modifiedBy"
                type="text"
              />
              <ValidatedField
                label={translate('reachamyApp.blogTable.modifiedAt')}
                id="blog-table-modifiedAt"
                name="modifiedAt"
                data-cy="modifiedAt"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/blog-table" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BlogTableUpdate;
